import { render } from "./FoolFight.vue?vue&type=template&id=5e6d1288"
import script from "./FoolFight.vue?vue&type=script&lang=js"
export * from "./FoolFight.vue?vue&type=script&lang=js"

import "./FoolFight.vue?vue&type=style&index=0&id=5e6d1288&lang=scss"
script.render = render

export default script